<div id="irt-vehicle-detail-revisions-add-root-layout">
  <div  class="irt-full-width irt-spaced-row irt-padding"
        style="padding-bottom: 0;">
    <h3 class="irt-no-margin irt-primary-medium-color"> 
      Aggiungi manutenzione
    </h3> 
    <button mat-icon-button (click)="onDialogCloseClick()">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <form id="irt-vehicle-detail-revisions-add-content-layout" class="irt-form" [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="irt-full-width">
      <mat-label> Data </mat-label>
      <input matInput type="text" required
             formControlName="date"
             [matDatepicker]="datePicker">
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="irt-full-width">
      <mat-label> Km </mat-label>
      <input matInput type="number" min="0" formControlName="km" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="irt-full-width">
      <mat-label> Note </mat-label>
      <textarea matInput type="text" formControlName="note" required></textarea>
    </mat-form-field>
  </form>

  <div class="irt-full-width irt-centered-row irt-double-margin-bottom">
    <button class="irt-main-button" mat-button (click)="onDialogConfirmClick()">
      <p class="irt-no-margin" *ngIf="!showButtonSpinner"> Aggiungi manutenzione </p>
      <div class="irt-spinner-layout" *ngIf="showButtonSpinner">
        <mat-spinner [diameter]="20" color="accent"> </mat-spinner>
      </div>
    </button>
  </div>
</div>
